/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusEmailProtokollStatisticsDto } from '../../models/lexplus-email-protokoll-statistics-dto';

export interface EmailProtokollControllerReadStatisticsV1$Params {
  from: string;
  to: string;
}

export function emailProtokollControllerReadStatisticsV1(http: HttpClient, rootUrl: string, params: EmailProtokollControllerReadStatisticsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusEmailProtokollStatisticsDto>> {
  const rb = new RequestBuilder(rootUrl, emailProtokollControllerReadStatisticsV1.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusEmailProtokollStatisticsDto>;
    })
  );
}

emailProtokollControllerReadStatisticsV1.PATH = '/v1/email-protokoll/statistics';
